<p-dialog *ngIf="prItem&&showDialog" [(visible)]="showDialog" header="Item Details"
          [modal]="true" [responsive]="true" [resizable]="false" [style]="PrimeNgConfig.DialogStyle65" (onHide)="hideDialog()" [contentStyle]="{'overflow-y':'scroll'}"
          [closable]="false">

  <div class="instruction-text">Select Master Catalog to add Shipping or Discount items.
  </div>

  <form class="add-line-item" #newLineItemForm="ngForm">

    <!-- User to select a catalog to search item -->
    <div class="ui-grid ui-grid-responsive ui-grid-pad ui-fluid" style="margin: 10px 0px">
      <div *ngIf="projectId" class="p-grid"
           [hidden]="!((txnType===Transaction.SalesOrder||txnType===Transaction.MaterialOrder) && showProjectTaskTree)">
        <div class="p-col-12 p-md-2 p-lg-2">
          <label *ngIf="requireProjectTask">Project Task*</label>
          <label *ngIf="!requireProjectTask">Project Task</label>
        </div>
        <div class="p-col-12 p-md-10 p-lg-10 charge-task-tree">
          <app-project-task-tree [projectId]="projectId" (handler)="handleProjectTask($event)"
                                 (handlerProjectTaskTreeSize)="handleProjectTaskTreeSize($event)"></app-project-task-tree>
        </div>
        <div class="p-col-12 p-md-6 p-lg-6">
          <strong>{{ prItem?.taskName ? prItem.taskName : '' }}</strong>
        </div>
        <div *ngIf="(txnType===Transaction.SalesOrder||txnType===Transaction.MaterialOrder) && !showProjectTaskTree">
          <span class="inline-alert-error"><i class="fa fa-exclamation-triangle"></i></span>
          Selected Project do not have any associated tasks.
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-2 p-lg-2">
          <label style="margin-top:0;">Catalog* </label>
        </div>

        <div class="p-col-12 p-md-1 p-lg-1">
          <button pButton type="button" class="icon-action" icon="fa fa-th-list" style="margin:-5px 0 0 5px;"
                  (click)="catalogOp.show($event)"
                  [disabled]="viewOnly"></button>
          <div class="pr-catalog-menu">
            <p-overlayPanel styleClass="catalog-selection-overlay" #catalogOp [dismissable]="true" [showCloseIcon]="true">
              <p-tree [value]="catalogTree" [style]="{'width':'100%'}" [styleClass]="'tree-container'" selectionMode="single"
                      [(selection)]="selectedCatalog"
                      (onNodeSelect)="onNodeSelectCatalogTree($event.node, catalogOp)">
              </p-tree>
            </p-overlayPanel>
          </div>
        </div>

        <div class="p-col-12 p-md-9 p-lg-9">
          <strong>{{ selectedCatalog ? selectedCatalog.name : '' }}</strong>
        </div>
      </div>

      <!-- User to search for an item after selected a catalog -->

      <div class="p-grid">
        <div class="p-col-12 p-md-2 p-lg-2">
          <label>Search*</label>
        </div>

        <div class="p-col-12 p-md-10 p-lg-10">
          <p-autoComplete name="selectedAbstractItem" class="autoComplete" field="nameOrNumber" [readonly]="viewOnly"
                          [minLength]="Validation.AutoCompleteMinLength" [placeholder]="Validation.AutoCompletePlaceholder" [showEmptyMessage]="true"
                          [suggestions]="filteredAbstractItems"
                          [(ngModel)]="selectedAbstractItem" (completeMethod)="searchItem($event.query, itemType, itemTypeGroup, txnType)" (onSelect)="onSelectItem(selectedAbstractItem, txnType)"
                          (onUnselect)="onClearItem()" [disabled]="!selectedCatalog" required>
            <ng-template let-selectedAbstractItem pTemplate="item">
              {{selectedAbstractItem.nameOrNumber}}
              <span *ngIf="selectedAbstractItem.projectName">
                ({{selectedAbstractItem.projectName}})
              </span>
            </ng-template>

          </p-autoComplete>
        </div>
      </div>

      <!-- Show selected item detail including type, unit price, manufacturer number, u/m, commodity code, description and item notes -->

      <div class="p-grid add-item-readonly" style="font-weight:normal;">
        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Name</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem?.nameOrNumber}}
            </div>
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Type</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem?.subtype | titleCase}}
            </div>
          </div>
        </div>

        <div *ngIf="txnType!==Transaction.SalesOrder && txnType!==Transaction.CustomerInvoice" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Funding Type</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem?.fundingType | titleCase}}
            </div>
          </div>
        </div>

        <div *ngIf="txnType===Transaction.SalesOrder || txnType===Transaction.CustomerInvoice&& (prItem?.subtype!==ItemType.Shipping) && (prItem?.subtype!==ItemType.Discount)"
             class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Sales Price</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{ prItem ? (prItem.salesPrice | currency: Format.Currency) : '' }}
            </div>
          </div>
        </div>

        <div *ngIf="txnType!==Transaction.SalesOrder && txnType!==Transaction.CustomerInvoice && (prItem?.subtype!==ItemType.Shipping) && (prItem?.subtype!==ItemType.Discount)"
             class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Unit Cost</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{ prItem ? (prItem.unitCost | currency: Format.Currency) : '' }}
            </div>
          </div>
        </div>

        <div *ngIf="prItem?.manufacturerNumber" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Manu #</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem ? prItem.manufacturerNumber : '' }}
            </div>
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">U/M</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{ prItem?.unitOfMeasureDescription}}
            </div>
          </div>
        </div>

        <div *ngIf="prItem?.subtype===ItemType.Service && prItem?.projectName" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Project Name</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem?.projectName}}
            </div>
          </div>
        </div>

        <div *ngIf="prItem?.subtype===ItemType.Service && prItem?.projectLaborCategoryPositionTitle" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Project Labor Category</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem?.projectLaborCategoryPositionTitle}}
            </div>
          </div>
        </div>

        <div *ngIf="selectedAbstractItem?.subtype===ItemType.Service && txnType!==Transaction.MaterialOrder && txnType!==Transaction.SalesOrder"
             class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Service Available</label>
            </div>
            <div *ngIf="requiredDeliveryDateWithinEffectiveDates&&(selectedAbstractItem?.effectiveFrom||selectedAbstractItem?.effectiveThru)"
                 class="p-col-12 p-md-8 p-lg-8">
              {{selectedAbstractItem?.effectiveFrom}} ~ {{selectedAbstractItem?.effectiveThru}}
            </div>
            <div *ngIf="!requiredDeliveryDateWithinEffectiveDates&&(selectedAbstractItem?.effectiveFrom||selectedAbstractItem?.effectiveThru)"
                 class="p-col-12 p-md-8 p-lg-8"
                 style="color: red;">
              {{selectedAbstractItem?.effectiveFrom}} ~ {{selectedAbstractItem?.effectiveThru}}
            </div>
            <div *ngIf="!requiredDeliveryDateWithinEffectiveDates"
                 class="p-grid">
              <div class="p-col-12 p-md-4 p-lg-4">
              </div>
              <div class="p-col-12 p-md-8 p-lg-8" style="color: red;">
                This service item cannot be added because it is not available for the required delivery date ({{requiredDeliveryDate}}).
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="prItem?.commodityCodeDescription && txnType!==Transaction.MaterialOrder" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Commodity Code</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem?.commodityCodeDescription}}
            </div>
          </div>
        </div>

        <div *ngIf="prItem?.quantityOnHand" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Qty. On Hand</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem?.quantityOnHand}}
            </div>
          </div>
        </div>

        <div *ngIf="prItem?.description" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label style="">Description</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{prItem.description}}
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-12 p-lg-12">
          <div *ngIf="prItem?.itemNotes" class="p-grid">
            <div class="p-col-12 p-md-2 p-lg-2">
              <label style="">Item Notes</label>
            </div>
            <div class="p-col-12 p-md-10 p-lg-10">
              {{prItem.itemNotes}}
            </div>
          </div>
        </div>
      </div>

      <div class="p-col-12">&nbsp;</div>

      <!-- User to enter input after selecting an item -->

      <div *ngIf="prItem">
        <div *ngIf="txnType===Transaction.PurchaseRequisition || txnType===Transaction.SalesOrder || txnType===Transaction.MaterialOrder || txnType===Transaction.BillOfMaterial"
             class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label class="no-top-margin">Qty. Ordered*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p *ngIf="(prItem?.subtype===ItemType.Discount) || (prItem?.subtype===ItemType.Shipping)">{{prItem.qtyOrdered}}</p>
            <p-spinner *ngIf="(prItem?.subtype!==ItemType.Discount) && (prItem?.subtype!==ItemType.Shipping)"
                       name="qtyOrdered" [readonly]="viewOnly" size="12"
                       [(ngModel)]="prItem.qtyOrdered"
                       (input)="calculateQtyBackOrdered(prItem, txnType, salesTaxRate)"
                       (onChange)="calculateQtyBackOrdered(prItem, txnType, salesTaxRate)"
                       [disabled]="!prItem?.abstractItemId" required [step]="0.50">
            </p-spinner>
          </div>
        </div>


        <div *ngIf="txnType===Transaction.Receipt || txnType===Transaction.VendorInvoice &&  (prItem?.subtype!==ItemType.Shipping) && (prItem?.subtype !==ItemType.Discount)"
             class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label class="no-top-margin">Qty. Received*</label>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <p-spinner *ngIf="prItem?.subtype!==ItemType.Service"
                       name="qtyReceived" [min]="0" size="12" [(ngModel)]="prItem.qtyReceived"
                       (input)="calculateQtyBackOrdered(prItem, txnType, salesTaxRate)"
                       (onChange)="calculateQtyBackOrdered(prItem, txnType, salesTaxRate)"
                       [disabled]="!prItem?.abstractItemId"
                       required [step]="1"></p-spinner>
            <p-spinner *ngIf="prItem?.subtype===ItemType.Service"
                       id="qtyReceivedService" name="qtyReceived" [min]="0" size="12" [(ngModel)]="prItem.qtyReceived"
                       (input)="calculateQtyBackOrdered(prItem, txnType, salesTaxRate)"
                       (onChange)="calculateQtyBackOrdered(prItem, txnType, salesTaxRate)"
                       [disabled]="!prItem?.abstractItemId"
                       required [step]="0.50"></p-spinner>
          </div>
        </div>


        <div *ngIf="(prItem?.subtype===ItemType.Shipping)" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label class="no-top-margin">Unit Cost*</label>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input name="costForShipping" type="number" pKeyFilter="money" maxlength="6"
                     [(ngModel)]="prItem.unitCost"
                     (input)="calculateExtendedPriceForDefaultItems(prItem, txnType)" required/>
            </span>
          </div>
        </div>

        <div *ngIf="(prItem?.subtype===ItemType.Discount)" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label class="no-top-margin">Discount*</label>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <span class="p-inputgroup">
              <input name="costForDiscount" type="number" min="0" pKeyFilter="money" maxlength="4"
                     [(ngModel)]="prItem.unitCost"
                     (input)="calculateExtendedPriceForDefaultItems(prItem, txnType)" required/>
              <span class="p-inputgroup-addon">%</span>
            </span>
          </div>
        </div>

        <div *ngIf="txnType===Transaction.CustomerInvoice" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label class="no-top-margin">Qty. Delivered*</label>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <p *ngIf="(prItem?.subtype===ItemType.Discount) || (prItem?.subtype===ItemType.Shipping)">1</p>
            <p-spinner *ngIf="(prItem?.subtype!==ItemType.Discount) && (prItem?.subtype!==ItemType.Shipping)"
                       name="qtyDelivered" [min]="0" size="12" [(ngModel)]="prItem.qtyDelivered"
                       (input)="itemCatalogService.updateTaxForPrItem(prItem, txnType, salesTaxRate)"
                       (onChange)="itemCatalogService.updateTaxForPrItem(prItem, txnType, salesTaxRate)"
                       required [step]="0.50">
            </p-spinner>
          </div>
        </div>


        <div *ngIf="txnType===Transaction.MaterialOrder" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label class="no-top-margin">Qty. Back Ordered*</label>
          </div>

          <div *ngIf="prItem.qtyBackOrdered" class="p-col-12 p-md-4 p-lg-4"> {{prItem.qtyBackOrdered}}
          </div>
          <div *ngIf="prItem.qtyBackOrdered===0" class="p-col-12 p-md-4 p-lg-4">0</div>
        </div>

        <div *ngIf="txnType===Transaction.VendorInvoice && (prItem?.subtype!==ItemType.Discount) &&(prItem?.subtype!==ItemType.Shipping)"
             class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Actual Unit Cost*</label>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="actualUnitCost" type="number" [readonly]="viewOnly" pKeyFilter="money" size="30"
                     style="max-width:188px!important;"
                     [(ngModel)]="prItem.actualUnitCost"
                     (input)="itemCatalogService.updateTaxForPrItem(prItem, txnType, salesTaxRate)" [disabled]="!prItem?.abstractItemId" required/>
            </div>
          </div>
        </div>

        <div *ngIf="(txnType===Transaction.PurchaseRequisition || txnType===Transaction.VendorInvoice || txnType===Transaction.SalesOrder || txnType===Transaction.CustomerInvoice)
        && (prItem?.subtype!==ItemType.Discount)&& (prItem?.subtype!==ItemType.Shipping)"
             class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label class="no-top-margin">Extended Price</label>
          </div>
          <div *ngIf="txnType===Transaction.VendorInvoice && prItem.actualUnitCost" class="p-col-12 p-md-4 p-lg-4">
            {{ prItem && prItem.qtyReceived ? ((prItem.actualUnitCost * prItem.qtyReceived) | currency: Format.Currency) : '' }}
          </div>
          <div *ngIf="txnType===Transaction.PurchaseRequisition || (txnType===Transaction.VendorInvoice &&! prItem.actualUnitCost)"
               class="p-col-12 p-md-4 p-lg-4">
            {{prItem && prItem.unitCost && prItem.qtyOrdered ? ((prItem.unitCost * prItem.qtyOrdered) | currency: Format.Currency) : '' }}
          </div>
          <div *ngIf="txnType===Transaction.SalesOrder"
               class="p-col-12 p-md-4 p-lg-4">
            {{ prItem && prItem.salesPrice && prItem.qtyOrdered ? ((prItem.salesPrice * prItem.qtyOrdered) | currency: Format.Currency) : '' }}
          </div>
          <div *ngIf="txnType===Transaction.CustomerInvoice"
               class="p-col-12 p-md-4 p-lg-4">
            {{ prItem && prItem.salesPrice && prItem.qtyDelivered ? ((prItem.salesPrice * prItem.qtyDelivered) | currency: Format.Currency) : '' }}
          </div>
        </div>


        <div *ngIf="(txnType===Transaction.PurchaseRequisition || txnType===Transaction.SalesOrder || txnType===Transaction.VendorInvoice|| itemTypeGroup === ItemTypeGroup.Expense)
         && (prItem?.subtype!==ItemType.Discount) && (prItem?.subtype!==ItemType.Shipping)"
             class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Taxable</label>
          </div>

          <div class="p-col-12 p-md-8 p-lg-8">
            <p-checkbox name="isTaxable" binary="true"
                        [(ngModel)]="prItem.isTaxable"
                        (onChange)="itemCatalogService.updateTaxForPrItem(prItem, txnType, salesTaxRate)"
                        [disabled]="viewOnly || !prItem?.abstractItemId">
            </p-checkbox>
          </div>


          <div *ngIf="prItem.isTaxable" class="p-col-12 p-md-4 p-lg-4">
            <label>Sales Tax</label>
          </div>
          <div *ngIf="prItem.isTaxable" class="p-col-12 p-md-8 p-lg-8">
            {{prItem?.taxAmount | currency: Format.Currency}}
          </div>

        </div>


        <div *ngIf="txnType===Transaction.PurchaseRequisition || txnType===Transaction.SalesOrder" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Line Notes</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="lineNotes" type="text" [readonly]="viewOnly"
                   [maxlength]="Validation.DescriptionMaxLength"
                   [(ngModel)]="prItem.lineNotes" [disabled]="!prItem?.abstractItemId"/>
          </div>
        </div>


        <div *ngIf="txnType===Transaction.PurchaseRequisition || (txnType===Transaction.SalesOrder && user?.info?.subtype !== UserType.Customer) ||
             txnType===Transaction.VendorInvoice || txnType===Transaction.Receipt || txnType===Transaction.CustomerInvoice"
             class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Internal Notes</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="internalNotes" type="text"
                   [maxLength]="Validation.DescriptionMaxLength"
                   [(ngModel)]="prItem.internalNotes"
                   [disabled]="!prItem?.abstractItemId"/>
          </div>
        </div>
      </div>

      <app-data-table
        *ngIf="prItem && (txnType===Transaction.PurchaseRequisition || txnType===Transaction.VendorInvoice) && (prItem?.subtype!==ItemType.Shipping) && (prItem?.subtype!==ItemType.Discount)"
        [columns]="tableColumns" [value]="prItem.purchaseChargeCodes" sortField="chargeNumber" [captionTemplate]="captionTemplate" [bodyTemplate]="bodyTemplate">

        <ng-template #captionTemplate>
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4" style="text-align:left;">
              <h5>Charge Code*</h5>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8" style="text-align:right;">
              <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Charge Code"
                      (click)="onClickAddChargeCode()"
                      [disabled]="viewOnly || !prItem?.abstractItemId || totalAllocation >= 100">
              </button>
            </div>
          </div>
        </ng-template>


        <ng-template #bodyTemplate let-row="row" let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <span class="p-column-title">{{col.header}}</span>
              <span class="p-cell">
                <div *ngSwitchCase="'allocationPercent'">{{row[col.field]}}%</div>
                <div *ngSwitchCase="'action'">
                  <button pButton type="button" class="icon-action" icon="fa fa-pencil" (click)="onClickEditChargeCode(row)"></button>
                  <button pButton type="button" class="icon-negative" icon="fa fa-trash" (click)="onClickDeleteChargeCode(row)"></button>
                </div>
                <div *ngSwitchDefault>{{row[col.field]}}</div>
              </span>
            </td>
          </tr>
        </ng-template>

      </app-data-table>
    </div>
  </form>

  <p-footer>
    <div *ngIf="duplicateItemError" class="padding-top:10px;text-align:right;">
      <i class="fa fa-warning" style="color:red"></i> {{duplicateItemError}}
    </div>
    <div style="text-align:right;padding-top:10px;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="hideDialog()"></button>

      <button *ngIf="(txnType===Transaction.PurchaseRequisition || txnType===Transaction.VendorInvoice) && prItem?.subtype!==ItemType.Shipping && prItem?.subtype!==ItemType.Discount"
              pButton type="button" class="button-action" icon="fa fa-check" label="Add/Update"
              (click)="onClickAddItem(prItem, txnType, salesTaxRate)"
              [disabled]="!newLineItemForm.form.valid || totalAllocation < 100
                          || (prItem?.subtype===ItemType.Service&&requiredDeliveryDate&&!requiredDeliveryDateWithinEffectiveDates)
                          || duplicateItemError">
      </button>

      <button *ngIf="txnType===Transaction.Receipt || txnType===Transaction.MaterialOrder||txnType===Transaction.BillOfMaterial ||
              txnType===Transaction.SalesOrder|| txnType===Transaction.CustomerInvoice || (prItem?.subtype===ItemType.Shipping) || (prItem?.subtype===ItemType.Discount)"
              pButton type="button" class="button-action" icon="fa fa-check" label="Add/Update"
              (click)="onClickAddItem(prItem, txnType, salesTaxRate)"
              [disabled]="!newLineItemForm.form.valid || !selectedAbstractItem?.id
                          || (prItem?.subtype===ItemType.Service&&txnType!==Transaction.SalesOrder&&requiredDeliveryDate&&!requiredDeliveryDateWithinEffectiveDates)
                          || (projectId && requireProjectTask && !prItem?.taskId) || duplicateItemError">
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog *ngIf="chargeCodeToEdit&&displayChargeCodeDialog" [(visible)]="displayChargeCodeDialog"
          header="Charge Code Details" [modal]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40" [contentStyle]="{'min-height':'300px'}">
  <div class="ui-grid ui-grid-responsive ui-grid-pad ui-fluid" style="margin: 10px 0px">
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Charge Code*</label>
      </div>

      <div class="p-col-12 p-md-8 p-lg-8">
        <app-my-charge-code-dropdown [txnType]="txnType" [chargeCodeId]="chargeCodeToEdit?.chargeCodeId"
                                     [userId]="userId"
                                     [authorizedFrom]="authorizedFrom" [authorizedThru]="authorizedThru"
                                     [chargeCodesToExclude]="chargeCodesToExclude" [chargeCodeTypesToInclude]="includeChargeCodeTypes"
                                     (handler)="handleSelectedChargeCode($event)">
        </app-my-charge-code-dropdown>
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Allocation*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <div class="p-inputgroup">
          <input name="allocationPercent" type="number" min="1" [max]="availableAllocation" [(ngModel)]="chargeCodeToEdit.allocationPercent" required
                 step="1"/>
          <span class="p-inputgroup-addon">%</span>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <div style="padding-top:10px;text-align:right;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="hideChargeCodeDialog()"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Add/Update"
              (click)="onClickSaveChargeCode(chargeCodeToEdit)"
              [disabled]="(!chargeCodeToEdit?.chargeCodeId || chargeCodeToEdit.allocationPercent === null || chargeCodeToEdit.allocationPercent === undefined) ||
                (chargeCodeToEdit.allocationPercent > availableAllocation)">
      </button>
    </div>
  </p-footer>

</p-dialog>
